// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum EventType {
    CO2 = 1,
    CameraConnected = 101,
    OuterGamConnected = 102,
    InnerGamConnected = 103,
    AmbientRhtConnected = 104,
    PlenumRhtConnected = 105,
    PlenumPressureConnected = 106,
    ContinuousMoistureConnected = 107,
    MainCanPowerCycling = 114,
    SecondaryCanPowerCycling = 115,
    UnresponsiveBoards = 116,
    StuckInBootloaderBoards = 117,
    TerminationMainBoards = 118,
    TerminationSecondaryBoards = 119,
    CellularAntennaConnected = 120,
    HotSpot = 2,
    AcVoltageOn = 220,
    FanRuntimeComplete = 3,
    FanCurrentCorrect = 307,
    HeaterCurrentCorrect = 308,
    LowHeaterCurrentCorrect = 309,
    HighHeaterCurrentCorrect = 310,
    MachineCurrentCorrect = 321,
    AugurCurrentCorrect = 322,
    PlenumTemp = 4,
    LostCellularConnection = 401,
    CellularConnectionWeak = 402,
    FanAmps = 5,
    AmbientRhtSuspect = 511,
    PlenumRhtSuspect = 512,
    PlenumPressureSuspect = 513,
    OuterCo2Suspect = 523,
    InnerCo2Suspect = 524,
    OuterRangeFinderSuspect = 525,
    InnerRangeFinderSuspect = 526,
    OuterHeadspaceRhtSuspect = 527,
    InnerHeadspaceRhtSuspect = 528,
    ContinuousMoistureSuspect = 529,
    SeedPlenumTemp = 6,
    PlenumTemperatureOutsideLimit = 601,
    LsgoDrying = 602,
    OffFan = 603,
    OnFan = 604,
    FanTimer = 605,
    FanOperationsLimits = 607,
    PausedFanTimer = 609,
    ResumedFanTimer = 610,
    TempOutsideLimitFan = 611,
    McOutsideLimitFan = 612,
    CyclesOffDrying = 613,
    MoistureNotChangingDrying = 614,
    BadPlenumTemperatureDrying = 615,
    StartedDrying = 617,
    ImmediateStopDrying = 618,
    ImmediateStopDryingWeb = 619,
    ControlledStopDrying = 620,
    ControlledStopDryingWeb = 621,
    StoppedDrying = 622,
    DryingOperationsLimits = 623,
    GrainTempCalibration = 625,
    GrainTempCalibrationWeb = 626,
    PlenumTempCalibration = 627,
    PlenumTempCalibrationWeb = 628,
    MoistureTempCalibration = 629,
    MoistureTempCalibrationWeb = 630,
    MaxTempChanged = 631,
    MaxTempChangedWeb = 632,
    TargetMcChanged = 633,
    TargetMcChangedWeb = 634,
    PlenumTempBelowTarget = 636,
    PlenumTempAboveTarget = 639,
    DryerShutdown = 640,
    DryerShutdownWeb = 641,
    PowerLossControlledDryerStop = 642,
    MoistureLessThan40 = 643,
    MoveGrainStarted = 644,
    HighCo2 = 645,
    TargetPlenumTempChanged = 646,
    TargetPlenumTempChangedWeb = 647,
    StaticPressureReadingOutsideLimit = 648,
    SampleMcIsOutsideLimit = 649,
    CompressorPsi = 7,
    MachineGearBox = 701,
    RemoteStop = 703,
    FanOverCurrent = 704,
    PlenumOverTemp = 705,
    GrainOverTemp = 706,
    AugerOverCurrent = 707,
    AugerGearBox = 708,
    MachineOverCurrent1 = 709,
    MachineOverCurrent2 = 710,
}
export default EventType;
